<template>
  <div>
    <b-overlay
      :show="loader"
      rounded="sm"
    >
      <b-col
        v-if="epicfail===null && !isEmptyObject(request) "
        lg="12"
        md="12"
      >
        <app-collapse
          type="margin"
          class="mb-2"
        >
          <app-collapse-item :title="`Detalle de la orden ${request.id || 'No disponible'}`">
            <b-list-group>
              <!-- Iteramos sobre las propiedades del objeto ItemTran -->
              <b-list-group-item
                v-for="(value, key, index) in filteredItemOrder"
                :key="index"
              >
                <strong>{{ key }}:</strong>
                {{ value === 'null' || value === null ? 'No disponible' : value }}
              </b-list-group-item>
            </b-list-group>
          </app-collapse-item>
        </app-collapse>
        <b-input-group prepend="Motivo">
          <b-form-textarea
            id="txtobservaciones"
            v-model="formdata.observaciones"
            placeholder="Ingrese el motivo de cancelación."
            rows="3"
            no-resize
          />
        </b-input-group>
        <b-alert
          class="mt-2"
          show
          variant="warning"
        >
          <div class="alert-body">
            <feather-icon
              class="mr-25 large-icon"
              icon="AlertCircleIcon"
            />
            <span class="ml-25">Revisar si tiene planes de pago activos o si aun puede pagar.</span>
          </div>
        </b-alert>
        <div class="d-block mt-2 text-center">
          <b-button
            v-show="request.status == 'ACT'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="handleOk()"
          >
            <b-spinner
              v-show="flagproceder"
              small
              type="grow"
            />
            {{ (flagproceder) ? 'Trabajando...': 'Proceder' }}
          </b-button>
          <b-alert
            v-show="request.status=='CAN'"
            class="mt-2"
            show
            variant="info"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="InfoIcon"
              />
              <span class="ml-25">Esta solicitud ya fue cancelada.</span>
            </div>
          </b-alert>
        </div>
      </b-col>
      <b-col v-else>
        <b-card
          border-variant="warning"
          title="Lo sentimos, problemas al cargar la orden"
          bg-variant="transparent"
          class="shadow-none"
        >
          <b-card-text>
            Lo sentimos, {{ epicfail }}. estaremos de vuelta tan pronto sea posible.
          </b-card-text>
        </b-card>
      </b-col>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCol,
  BAlert,
  BInputGroup,
  BFormTextarea,
  BButton,
  BSpinner,
  BCard,
  BCardText,
  BListGroup,
  BListGroupItem,
  BOverlay,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { frmstatus } from '@core/utils/filter'
import { isEmptyObject } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import { RESUMEN_X_ORDEN } from './useTareas'

export default {
  components: {
    BCol,
    BAlert,
    BInputGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    BCard,
    BCardText,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    orden: {
      type: Number,
      require: true,
      default: () => null,
    },
    openModal: {
      type: Boolean,
      require: true,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    // Definición de variables reactivas
    const flagproceder = ref(false)
    const loader = ref(false)
    const toast = useToast()
    const objectOrden = ref({})
    const request = ref({})
    const planRequest = ref({})
    const formdata = ref({
      observaciones: null,
      orden: null,
      action: 26,
    })
    const epicfail = ref(null)

    // Lista de claves a ocultar
    const ocultarClaves = ref(['id', 'plan', 'persona_fk', 'precioFinal', 'idTipBeca', 'abrev_beca'])

    // Computed que filtra el objeto
    const filteredItemOrder = computed(() => {
      if (!request.value) return {} // Si aún no hay datos, devolvemos un objeto vacío
      return Object.fromEntries(
        Object.entries(request.value).filter(([key]) => !ocultarClaves.value.includes(key)),
      )
    })

    const resetModal = () => {
      formdata.value = {
        observaciones: null,
        orden: null,
      }
    }

    // Funciones
    const OrdenReject = async datos => {
      try {
        flagproceder.value = true

        const response = await store.dispatch('compras/postCompras', datos)

        if (response.status !== 200) {
          // console.log(response.message)
          throw new Error(response.message)
        }

        flagproceder.value = false

        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: response.message,
            icon: 'CheckSquareIcon',
            variant: 'success',
          },
        }, { timeout: 6000, position: 'top-center' })
        // clear form
        resetModal()
        emit('update:openModal', false) // Emite el evento con el nuevo valor
        emit('reload-data')
      } catch (error) {
        flagproceder.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error || 'Ocurrió un error inesperado',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        }, { timeout: 10000 })
      }
    }

    const fetchOrderSummary = async iden => {
      try {
        //  GET DATA
        loader.value = true
        const response = await RESUMEN_X_ORDEN(iden)
        // console.log(response)
        const { solicitud, plan } = response.datos
        request.value = solicitud
        planRequest.value = plan
        epicfail.value = null // Limpiar cualquier error previo
        loader.value = false
      } catch (err) {
        loader.value = false
        epicfail.value = `Error al obtener el resumen de la orden: ${err.message || err}`
        objectOrden.value = {} // Limpiar datos previos en caso de error
      }
    }

    const handleOk = () => {
      if (formdata.value.observaciones !== null && formdata.value.observaciones.length >= 15) {
        // Call api for upd
        formdata.value.orden = props.orden
        OrdenReject(formdata.value)
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Es importante ingrese el motivo y debe ser mayor a 15 caracteres',
            icon: 'AlertCircleIcon',
            variant: 'warning',
            solid: true,
          },
        }, { timeout: 10000 })
      }
    }

    // Ciclo de vida
    onMounted(() => {
      // console.log(`El componente ha sido montado y trabaja con ${props.orden}`)
      if (props.orden) {
        fetchOrderSummary(props.orden)
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Por favor instale el componente correctamente, orden no encontrada',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        }, { timeout: 10000 })
      }
    })

    // Retornar las propiedades y métodos que se usarán en la plantilla
    return {
      formdata,
      request,
      planRequest,
      epicfail,
      filteredItemOrder,
      // flags
      flagproceder,
      loader,
      // functions
      OrdenReject,
      frmstatus,
      isEmptyObject,
      handleOk,
    }
  },
}
</script>

  <style scoped>
  /* Estilos específicos del componente */
  p {
    color: #42b983;
  }
  .large-icon {
    font-size: 2em;
  }
  </style>
